import { z } from 'zod';
import type { ClaimActionType } from '../lib/claimActionRbac';

const moneySchema = z.object({
  amount: z.number().int().nonnegative(),
  currencyCode: z.string().length(3),
});

const baseSchema = z.object({
  note: z.string().max(2000).optional().default(''),
  reasonCode: z.string().max(64).optional().default(''),
  refundOverrideAmount: moneySchema.nullable().optional(),
});

export type AdminClaimProcessValues = z.infer<typeof baseSchema>;

export const validateClaimAction = (
  action: ClaimActionType,
  values: AdminClaimProcessValues,
): { ok: true } | { ok: false; field: 'note' | 'reasonCode'; code: string } => {
  if (action === 'reject') {
    if (!values.note || values.note.trim().length === 0) {
      return { ok: false, field: 'note', code: 'CLAIM_REJECT_REQUIRES_REASON' };
    }
    if (!values.reasonCode || values.reasonCode.trim().length === 0) {
      return { ok: false, field: 'reasonCode', code: 'CLAIM_REJECT_REQUIRES_REASON' };
    }
  }
  return { ok: true };
};

export const adminClaimProcessSchema = baseSchema;
